import React from 'react'

const InfoChangesContent = ({oldData, newData}) => {
    console.log(oldData);
    console.log(newData);
    return (
        <div className='info-changes-content'>
            {oldData && Object.keys(oldData).map(dataKey => (
                <div>
                    <span className='info-changes-label'>{oldData[dataKey].label}: </span> 
                    <span>
                        {oldData[dataKey][dataKey]} {'=>'} <strong> {newData[dataKey]}</strong>
                    </span>
                </div>
            ))}
        </div>
    )
}

export default InfoChangesContent


// WEBPACK FOOTER //
// ./src/components/admin/reviewers/info-changes/InfoChangesContent.js